"use strict";
/**
 * @Author: Perch Voskerchyan
 * @Date: 30.03.2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var a11y_1 = require("@angular/cdk/a11y");
var accordion_1 = require("@angular/cdk/accordion");
var bidi_1 = require("@angular/cdk/bidi");
var observers_1 = require("@angular/cdk/observers");
var overlay_1 = require("@angular/cdk/overlay");
var platform_1 = require("@angular/cdk/platform");
var portal_1 = require("@angular/cdk/portal");
var table_1 = require("@angular/cdk/table");
var flex_layout_1 = require("@angular/flex-layout");
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
/**
 * NgModule that includes all Material modules that are required to serve the sis-ui-settings.
 */
var MaterialModule = /** @class */ (function () {
    function MaterialModule() {
    }
    MaterialModule.decorators = [
        { type: core_1.NgModule, args: [{
                    exports: [
                        material_1.MatAutocompleteModule,
                        material_1.MatButtonModule,
                        material_1.MatButtonToggleModule,
                        material_1.MatCardModule,
                        material_1.MatCheckboxModule,
                        material_1.MatChipsModule,
                        material_1.MatTableModule,
                        material_1.MatDatepickerModule,
                        material_1.MatDialogModule,
                        material_1.MatDividerModule,
                        material_1.MatExpansionModule,
                        material_1.MatFormFieldModule,
                        material_1.MatGridListModule,
                        material_1.MatIconModule,
                        material_1.MatInputModule,
                        material_1.MatListModule,
                        material_1.MatMenuModule,
                        material_1.MatPaginatorModule,
                        material_1.MatProgressBarModule,
                        material_1.MatProgressSpinnerModule,
                        material_1.MatRadioModule,
                        material_1.MatRippleModule,
                        material_1.MatSelectModule,
                        material_1.MatSidenavModule,
                        material_1.MatSlideToggleModule,
                        material_1.MatSliderModule,
                        material_1.MatSnackBarModule,
                        material_1.MatSortModule,
                        material_1.MatStepperModule,
                        material_1.MatTabsModule,
                        material_1.MatToolbarModule,
                        material_1.MatTooltipModule,
                        material_1.MatNativeDateModule,
                        table_1.CdkTableModule,
                        a11y_1.A11yModule,
                        bidi_1.BidiModule,
                        accordion_1.CdkAccordionModule,
                        observers_1.ObserversModule,
                        overlay_1.OverlayModule,
                        platform_1.PlatformModule,
                        portal_1.PortalModule,
                        flex_layout_1.FlexLayoutModule,
                    ],
                },] },
    ];
    /** @nocollapse */
    MaterialModule.ctorParameters = function () { return []; };
    return MaterialModule;
}());
exports.MaterialModule = MaterialModule;
//# sourceMappingURL=material.module.js.map